import { styled } from '@linaria/react';
import { fonts, semantic, space } from '../../theme/tokens';

export const Label = styled.label`
  display: inline-flex;
  align-items: center;
  gap: ${space['space-200']};
  cursor: pointer;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.primary};

  &[data-disabled='true'] {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const Input = styled.input`
  appearance: none;
  width: 24px;
  height: 24px;
  border: 2px solid ${semantic.border.default};
  border-radius: 6px;
  margin: 0;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
  background: ${semantic.bg.canvas};
  transition: background 0.15s ease, border-color 0.15s ease;

  &:checked {
    background: ${semantic.bg.positiveStrong};
    border-color: ${semantic.border.positive};
  }

  &:checked::after {
    content: '';
    position: absolute;
    top: 3px;
    left: 7px;
    width: 6px;
    height: 10px;
    border: solid ${semantic.text.inverse};
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }

  &:disabled {
    cursor: not-allowed;
  }
`;
